import clsx from 'clsx'
import { useMemo } from 'react'

import { Text } from '@wartek-id/text-v1'
import type { IconProps } from '@wartek-id/icon-v2'
import { Icon } from '@wartek-id/icon-v2'

import type { HTMLProps } from 'react'

export interface PropsAnnouncement extends HTMLProps<HTMLDivElement> {
  type?: 'default' | 'success' | 'critical'
  title?: string
  description?: string
}

const Announcement = ({
  type = 'default',
  title,
  description,
  children,
  ...props
}: PropsAnnouncement) => {
  const icon = useMemo(() => {
    switch (type) {
      case 'success':
        return 'check_circle'
      case 'critical':
        return 'close'
      default:
        return 'hourglass_empty'
    }
  }, [type])

  return (
    <div
      {...props}
      className={clsx(
        'px-2.5 py-5 rounded flex flex-col items-center gap-2 border',
        {
          'bg-surface-success-subdued border-surface-success-default':
            type === 'success',
          'bg-white border-critical-default': type === 'critical',
          'bg-surface-selected-default border-default': type === 'default',
        },
        props.className
      )}
    >
      <Icon
        className="!text-[40px] !w-10 !h-10"
        color={type as IconProps['color']}
      >
        {icon}
      </Icon>

      {title && (
        <Text variant="heading-sm" className="text-center">
          {title}
        </Text>
      )}

      {children}

      {description && (
        <Text variant="body-sm" className="text-center" color="subdued">
          {description}
        </Text>
      )}
    </div>
  )
}

export default Announcement
